export default {
	methods: {
		getUrlFromSize(size, media) {
			const sizes = ['full', 'large', 'medium', 'small', 'full'];
			let activated = false;
			let url = null;

			// eslint-disable-next-line
			Object.keys(sizes).forEach((key) => {
				const currentSize = sizes[key];

				if (activated || size === currentSize) {
					const column = this.getMediaColumnBySize(currentSize);
					activated = true;

					if (media && media[column]) {
						url = media[column];
						activated = false;
					}
				}
			});

			return url;
		},

		getMediaColumnBySize(size) {
			if (size === 'full') {
				return 'url';
			}

			return `url_${size}`;
		},

		formatBlockType(type) {
			return type.replace('App\\', '');
		},

		detectIE() {
			const ua = window.navigator.userAgent;

			const msie = ua.indexOf('MSIE ');
			if (msie > 0) {
				// IE 10 or older => return version number
				return true;
			}

			const trident = ua.indexOf('Trident/');
			if (trident > 0) {
				// IE 11 => return version number
				return true;
			}

			// other browser
			return false;
		},

		cloneObject: (object) => {
			const stringifyObject = JSON.stringify(object);
			const parsedObject = JSON.parse(stringifyObject);
			return parsedObject;
		},

		cleanUrl(url) {
			url = this.removeTrailingSlash(url);
			url = this.removeTrailingLocale(url);
			url = this.removeProtocol(url);
			url = this.removeHashtag(url);
			return url;
		},

		removeTrailingSlash(string) {
			if (string && string.endsWith('/')) {
				string = string.slice(0, -1);
			}

			return string;
		},

		removeTrailingLocale(string) {
			if (string && (string.endsWith('/fr') || string.endsWith('/en'))) {
				string = string.slice(0, -3);
			}

			return string;
		},

		removeProtocol(string) {
			if (string) {
				string = string.replace('https://', '');
				string = string.replace('http://', '');
			}

			return string;
		},

		removeHashtag(string) {
			if (string.indexOf('#') > 0) {
				string = string.substring(0, string.indexOf('#'));
			}

			return string;
		},

		englishDateToUniversal(date) {
			return date.split('/').join('-');
		},

		frenchDateToUniversal(date) {
			return date.split('/').reverse().join('-');
		},

		englishDateToFrench(date) {
			return date.split('/').reverse().join('/');
		},

		frenchDateToEnglish(date) {
			return date.split('/').reverse().join('/');
		},

		universalDateToEnglish(date) {
			return date.split('-').join('/');
		},

		universalDateToFrench(date) {
			return date.split('-').reverse().join('/');
		},

		getArrayDepth(array) {
			return Array.isArray(array)
				? 1 + Math.max(...array.map(this.getArrayDepth))
				: 0;
		},

		isHex(color) {
			const hexadecimalRegex = /^#([0-9A-F]{3}){1,2}$/i;
			return hexadecimalRegex.test(color);
		},

		isRGB(color) {
			const rgbRegex = /rgb\(\d{1,3},\s*\d{1,3},\s*\d{1,3}\)/;
			return rgbRegex.test(color);
		},

		isRGBA(color) {
			const rgbaRegex = /rgba\(\d{1,3},\s*\d{1,3},\s*\d{1,3},?\s\d?\.?\d*\)/;
			return rgbaRegex.test(color);
		},
	},
};
